




















import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BaseInputSearch",
  components: { BaseInput, BaseSpinner, BaseIcon },
  props: {
    placeholder: { type: String, required: true },
    value: { type: String, required: true },
    filterLoading: { type: Boolean, required: true },
  },
});
